/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Kelas_PriceInputs */

const en_cp_p_kelas_price = /** @type {(inputs: Cp_P_Kelas_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDR 279k`)
};

const id_cp_p_kelas_price = /** @type {(inputs: Cp_P_Kelas_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 279 rb`)
};

/**
* | output |
* | --- |
* | "IDR 279k" |
*
* @param {Cp_P_Kelas_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_kelas_price = /** @type {((inputs?: Cp_P_Kelas_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Kelas_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_kelas_price(inputs)
	return en_cp_p_kelas_price(inputs)
});